import Modal from './Modal.view';

export default Modal;
